const flights = {
  flight: "Penerbangan", // translated 
  flights: "Penerbangan", // translated 
  originDepartureDate: "Keberangkatan", // translated 
  destinationDepartureDate: "Kembali", // translated 
  outbound: "Keluar", // translated 
  inbound: "Masuk", // translated 
  travelTime: "Waktu perjalanan", // translated 
  selected: "terpilih", // translated 
  select: "Pilih", // translated 
  airline: "Perusahaan penerbangan", // translated 
  directFlight: "Penerbangan langsung", // translated 
  baggage: "Bagasi", // translated 
  stops: "Berhenti", // translated 
  nonStop: "Nonstop", // translated 
  oneStopMax: "Maks. satu pemberhentian", // translated 
  twoStopsMax: "Maksimal dua perhentian", // translated 
  anyStops: "Dengan perhentian apa pun", // translated 
  smallBaggage: "Bagasi kecil", // translated 
  bigBaggage: "Bagasi besar", // translated 
  smallAndBigBaggage: "Bagasi kecil dan besar", // translated 
  outboundStops: "Perhentian keluar", // translated 
  inboundStops: "Perhentian masuk", // translated 
  selectAirline: "Pilih Maskapai Penerbangan", // translated 
  baggageOption: "Opsi bagasi", // translated 
  outboundDepartureAfter: "Keberangkatan keluar setelahnya", // translated 
  outboundArrivalAfter: "Kedatangan outbound setelahnya", // translated 
  inboundDepartureAfter: "Keberangkatan masuk setelahnya", // translated 
  inboundArrivalTimeAfter: "Kedatangan masuk setelahnya", // translated 
  flightClass: "Kelas penerbangan", // translated 
  outboundDepAfter: "Keberangkatan setelahnya", // translated 
  outboundArrivalAfrer: "Keluar setelahnya", // translated 
  inboundDepAfter: "Keberangkatan setelahnya", // translated 
  inboundArrivalAfter: "Setibanya setelahnya", // translated 
  airlines: "Maskapai Penerbangan", // translated 
  lessThan: "Kurang dari", // translated 
  layover: "Singgah", // translated 
  duration: "Durasi", // translated 
  noClassPreference: "Tidak Ada Preferensi Kelas", // translated 
  economy: "Ekonomi", // translated 
  business: "Bisnis", // translated 
  with: "Dengan", // translated 
  without: "Tanpa", // translated 
  twoOrMore: "Dua atau lebih", // translated 
  departure: "Keberangkatan", // translated 
  return: "Kembali", // translated 
  submit: "Kirim", // translated 
  priceLessThan: "Harga kurang dari", // translated 
  durationLessThan: "Durasi kurang dari", // translated 
  layoverLessThan: "Singgah kurang dari", // translated 
  noLayover: "Tidak ada singgah", // translated 
  durationLowestFirst: "Durasi (terendah dulu)", // translated 
  durationHighestFirst: "Durasi (yang tertinggi terlebih dahulu)", // translated 
  idType: "Tipe ID", // translated 
  idPassportCode: "Kode ID/Paspor", // translated 
  expirationDate: "Tanggal habis tempo", // translated 
  frequentFlyerNumber: "Nomor Penumpang Sering", // translated 
  frequentFlyerAirline: "Maskapai Penerbangan Sering", // translated 
  dateOfBirth: "Tanggal lahir", // translated 
  infant: "Bayi", // translated 
  phone: "Telepon", // translated 
  title: "Judul", // translated 
  noLuggageIncluded: "Tidak Termasuk Bagasi", // translated 
  includesLuggage: "Termasuk Bagasi", // translated 
  outboundFlight: "Penerbangan Keluar", // translated 
  inboundFlight: "Penerbangan Masuk", // translated 
  flightNumber: "Nomor penerbangan", // translated 
  flightNumbers: "Nomor Penerbangan", // translated 
  cabinClassType: "Tipe Kelas Kabin", // translated 
  class: "Kelas", // translated 
  aircraft: "Pesawat terbang", // translated 
  aircraftType: "Jenis pesawat", // translated 
  airlineName: "Nama Maskapai Penerbangan", // translated 
  no: "TIDAK", // translated 
  yes: "Ya", // translated 
  anyFlights: "Penerbangan Apa Pun", // translated 
  oneStop: "Satu Perhentian", // translated 
  direct: "Langsung", // translated 
  directFlights: "Penerbangan langsung", // translated 
  all: "Semua", // translated 
  first: "Pertama", // translated 
  premiumEconomy: "Prem. Ekonomi", // translated 
  withBaggageOnly: "Hanya dengan Bagasi", // translated 
  oneWay: "SATU ARAH", // translated 
  roundTrip: "Perjalanan pulang pergi", // translated 
  withBaggage: "Dengan Bagasi", // translated 
  noBaggagePreference: "Tidak Ada Preferensi Bagasi", // translated 
  noBaggage: "Tanpa Bagasi", // translated 
  requiredFields: "Bidang yang Wajib Diisi", // translated 
  nonRequiredFields: "Bidang yang Tidak Wajib", // translated 
  cabinClass: "Kelas Kabin", // translated 
  brandName: "Nama merk", // translated 
  performNewSearch: "Lakukan pencarian baru", // translated 
  outboundDeparture: "Keberangkatan Keluar", // translated 
  inboundDeparture: "Keberangkatan Masuk", // translated 
  created: "Dibuat", // translated 
  freeCancellationAvailable: "Pembatalan Gratis Tersedia", // translated 
  freeCancellationDeadline: "Batas Waktu Pembatalan Gratis", // translated 
  externalReference: "Referensi Eksternal", // translated 
  outboundflightNumber: "Nomor Penerbangan Keluar", // translated 
  inboundflightNumber: "Nomor Penerbangan Masuk", // translated 
  arrival: "Kedatangan", // translated 
};


export default flights;
